import { useEffect } from 'react';
import { loadAssets } from './assets';
import { ToastProvider, useToast } from './components/Toasts';
import { useRoute } from './lib/router';
import type { Route } from './lib/router';
import { useServiceWorkerUpdates } from './lib/serviceWorker';
import { Home } from './screens/Home';
import { RoomScreen } from './screens/RoomScreen';
import { SoloScreen } from './screens/SoloScreen';
import { TutorialScreen } from './tutorial/TutorialScreen';

export function App() {
  const route = useRoute();
  useEffect(() => {
    void loadAssets();
  }, []);
  return (
    <ToastProvider>
      <Updates route={route} />
      {route.name === 'solo' ? (
        <SoloScreen />
      ) : route.name === 'learn' ? (
        <TutorialScreen />
      ) : route.name === 'room' ? (
        <RoomScreen key={route.code} code={route.code} />
      ) : (
        <Home />
      )}
    </ToastProvider>
  );
}

function Updates({ route }: { route: Route }) {
  const toast = useToast();
  useServiceWorkerUpdates(route, toast);
  return null;
}
